import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {debounceTime, takeUntil, tap} from 'rxjs/operators';
import {FilterCriterionInput} from '../../../models/filters/filter-criterion-input';
import {destroy$} from '../../destroyable';

const SEARCH_DEBOUNCE_TIME = 1000;

@Component({
    selector: 'text-search-input',
    templateUrl: './text-search-input.component.html',
    styleUrls: ['./text-search-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextSearchInputComponent implements OnInit {

    @Input()
    public searchFilter: FilterCriterionInput;

    public updateFilter = new Subject<any>();

    @Output()
    public readonly filterChange = new EventEmitter();

    public readonly destroy$ = destroy$();

    public ngOnInit(): void {
        this.updateFilter.pipe(
            debounceTime(SEARCH_DEBOUNCE_TIME),
            tap(value => this.filterChange.emit(value)),
            takeUntil(this.destroy$)
        ).subscribe();
    }

    public clearSearchFormControl(): void {
        this.searchFilter.query = null;
        this.filterChange.emit(null);
    }

}
